// src/utils/slotOverlap.js
// Lógica pura de solapamiento de horarios.
// ESPEJO EXACTO de functions/slotOverlap.js — si cambiás uno, cambiá el otro.
// El test src/utils/slotOverlap.test.js falla si divergen.

export function toMinutes(hhmm) {
  if (typeof hhmm !== 'string') return null;
  const m = hhmm.trim().match(/^(\d{1,2}):(\d{2})$/);
  if (!m) return null;
  const h = Number(m[1]);
  const min = Number(m[2]);
  if (h > 23 || min > 59) return null;
  return h * 60 + min;
}

export function formatMinutes(mins) {
  const total = Number(mins);
  if (!Number.isFinite(total)) return '';
  const h = Math.floor(total / 60);
  const m = Math.round(total % 60);
  return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}

export function parseRange(rangeLabel, fallbackDurationMin = 0) {
  if (typeof rangeLabel !== 'string') return null;
  const [rawStart, rawEnd] = rangeLabel.split(' - ');
  const start = toMinutes(rawStart);
  if (start === null) return null;

  let end = toMinutes(rawEnd);
  if (end === null) {
    const fallback = Number(fallbackDurationMin);
    if (!Number.isFinite(fallback) || fallback <= 0) return null;
    end = start + fallback;
  }
  if (end <= start) return null;
  return { start, end };
}

export function intervalsOverlap(a, b) {
  if (!a || !b) return false;
  return a.start < b.end && a.end > b.start;
}

export function findOverlap(candidate, intervals) {
  if (!candidate || !Array.isArray(intervals)) return null;
  for (const interval of intervals) {
    if (intervalsOverlap(candidate, interval)) return interval;
  }
  return null;
}
